import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IDataConnectionType } from './types/IDataConnection';

export interface IGetDataConnectionTypesResult extends IGetItemsResult {
  dataConnectionTypes: IDataConnectionType[];
}

export class GetDataConnectionTypesRequest extends Request<IGetItemsParams, IGetDataConnectionTypesResult> {
  constructor(params: IGetItemsParams) {
    super('getDataConnectionTypes', params);
  }
}
